import React, { useState } from "react";
import { Paper, Tab, Tabs, Box, Typography, Grid } from "@material-ui/core";
import QuadroVisualizacaoSimples from "./QuadroVisualizacaoSimples";
import QuadroVisualizacaoLista from "./QuadroVisualizacaoLista";
import QuadroVisualizacaoListaComposta from "./QuadroVisualizacaoListaComposta";
import VisaoLogo from "./VisaoLogo";
import jsonUtils from "../../utils/jsonUtils";
import QuadroVisualizacaoListaVertical from "./QuadroVisualizacaoListaVertical";
import RelatoriosDeConsulta from "../RelatoriosDeConsulta";

const VisaoVisualizacao = (props) => {
    const is_printing = props.is_printing;
    const relatorio = props.relatorio;
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const is_tabs =
        relatorio.parametros_visao && relatorio.parametros_visao.is_abas
            ? true
            : false;
    const tabs = is_tabs
        ? relatorio.parametros_visao.abas
        : [{ nome: "Relatório", ordem: 1, key: 1 }];
    const [tab, setTab] = useState(tabs[0].key);
    let cnpj_key = "";
    const cnpjs_anons = [];

    const is_anon = cnpjs_anons.includes(cnpj_key);

    const TabPanel = (props) => {
        const { children, value, index, ...other } = props;
        const quadros = relatorio.quadros
            .filter(
                (q) => is_printing || !is_tabs || q.parametros.key_aba == value
            )
            .sort((a, b) => {
                if (is_tabs && a.parametros.key_aba != b.parametros.key_aba) {
                    return a.parametros.key_aba - b.parametros.key_aba;
                }
                return a.parametros.ordem - b.parametros.ordem;
            });

        return (
            <div
                role="tabpanel"
                hidden={value !== index && !is_printing}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {is_printing && index == 1 ? (
                    <VisaoLogo
                        style={{ transform: "scale: 0" }}
                        relatorio={relatorio}
                    ></VisaoLogo>
                ) : (
                    <></>
                )}
                {value === index && (
                    <div>
                        {quadros.map((q) => (
                            <Box
                                className="pageBreak"
                                key={q.titulo}
                                xs={12}
                                md={
                                    q.parametros.tamanho
                                        ? q.parametros.tamanho
                                        : 12
                                }
                            >
                                <Box
                                    className="pageBreak"
                                    borderBottom={1}
                                    style={{ borderColor: "#DDD" }}
                                    paddingTop="1rem"
                                    paddingBottom="1rem"
                                    height="100%"
                                >
                                    {q.tipo == "1" && (
                                        <QuadroVisualizacaoSimples
                                            quadro={q}
                                            relatorio={relatorio.relatorio}
                                            is_anon={is_anon}
                                        />
                                    )}
                                    {q.tipo == "2" && (
                                        <QuadroVisualizacaoLista
                                            className="pageBreak"
                                            quadro={q}
                                            relatorio={relatorio.relatorio}
                                            is_printing={is_printing}
                                            is_anon={is_anon}
                                        />
                                    )}
                                    {q.tipo == "3" && (
                                        <QuadroVisualizacaoListaVertical
                                            className="pageBreak"
                                            quadro={q}
                                            relatorio={relatorio.relatorio}
                                            is_printing={is_printing}
                                            is_anon={is_anon}
                                        />
                                    )}
                                    {q.tipo == "5" && (
                                        <QuadroVisualizacaoListaComposta
                                            quadro={q}
                                            relatorio={relatorio.relatorio}
                                            is_anon={is_anon}
                                        />
                                    )}
                                </Box>
                            </Box>
                        ))}
                    </div>
                )}
            </div>
        );
    };

    return (
        <>
            <Box
                className="noPrint"
                borderBottom={1}
                style={{ borderColor: "#DDD" }}
            >
                <Tabs
                    value={tab}
                    onChange={(e, value) => {
                        setTab(value);
                    }}
                    indicatorColor="primary"
                    textColor="primary"
                    style={{ backgroundColor: "transparent", border: 0 }}
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    {tabs.map((tab) => (
                        <Tab key={tab.key} label={tab.nome} value={tab.key} />
                    ))}
                </Tabs>
            </Box>

            {tabs.map((t) => {
                if (t.tipo_customizado == "FINANCEIRO") {
                    return (
                        <RelatoriosDeConsulta
                            key={t.key}
                            value={tab}
                            index={t.key}
                            relatorio={relatorio.relatorio}
                        />
                    );
                }
                return <TabPanel key={t.key} value={tab} index={t.key} />;
            })}
        </>
    );
};

export default VisaoVisualizacao;
